var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBild(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 566.929,
    height: 602.362,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.717 10.385h531.496v581.592H17.717V10.385z",
    style: {
      fill: "#d91918",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.824 507.955h52.32V83.55h-52.32v424.405zM197.2 484.92c-.03 12.676-10.224 22.859-22.798 22.891H71.265l.032-424.261H174.53c12.447.02 22.641 10.212 22.67 22.888V255.15c0 11.99-9.828 21.674-21.809 21.674l-2.288-.012c13.252 0 24.098 10.776 24.098 24.015V484.92zm-73.61-348.985h21.477v120.9H123.59v-120.9zm0 172.85h21.477v146.524H123.59V308.785zm372.073 199.163V83.527H443.33v73.872h-50.918c-12.462.02-22.58 10.215-22.612 22.892l-.062 304.628c.033 12.676 10.224 22.86 22.798 22.891l103.126.136v.002zm-52.31-298.703h-21.477V455.31h21.476V209.245zm-223.492-73.31h52.317v-52.39h-52.316v52.39zm0 372.02h52.317V157.42h-52.316v350.535z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBild);
export default __webpack_public_path__ + "static/media/bild.f56d6514584a677b48eaa38e0259fd25.svg";
export { ForwardRef as ReactComponent };